import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { CategoryTableDataColumnType, CategoryTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const CategoryListTableData = [
  {
    foodCategoryId: 1,
    categoryName: "Fruits",
  },
  {
    foodCategoryId: 2,
    categoryName: "Vegetables",
  },
];

// const RfidCardListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
 try {
        await api.delete(`/api/FoodCategory/DeleteFoodCategoryById?foodCategoryId=${id}`);
       Swal.fire('Deleted!', 'Category has been deleted.', 'success');
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the category.', 'error');
        console.error("Delete error:", error);
      }
};

interface ProductListTableActionProps {
  foodCategoryId: any;
  onDelete: (id: number) => void;
}

export const CategoryTableAction: React.FC<ProductListTableActionProps> = ({ foodCategoryId, onDelete }) => {
  // const editUrl = `/rfid_card/edit/${foodCategoryId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this category!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(foodCategoryId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const CategoryTableOfferComponent: React.FC<CategoryTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const RechargeAmountTableStatus :React.FC<CategoryTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export  const CategoryListTableDataColumn: TableColumn<CategoryTableDataColumnType>[] = [
      {
        name: "Name",
        cell: (row) => <CategoryTableOfferComponent title={String(row.categoryName)}/>,
        sortable: true,
        grow: 2,
      },
      {
        name: "Action",
        cell: (row) => <CategoryTableAction foodCategoryId={row.foodCategoryId} onDelete={handleDelete} />,
      },
    ];

  export const filtersData = [
    {
      name: "Choose Category",
      options: ["Fruits", "Vegetables"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];